import { createFileRoute } from '@tanstack/react-router';

import { TimelinePage } from '@/features/owner/timeline-page';

export const Route = createFileRoute('/_app/projects/$projectId/timeline/activity')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <TimelinePage projectId={projectId} />;
}
